import { calendarMonthRange, previousCalendarMonth, previousDateRange, type DateRange, type PeriodKey } from "./dashboard-analytics.ts";
const iso = (date: Date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}-${String(date.getDate()).padStart(2,"0")}`;
export function periodComparisonRange(period: PeriodKey, range: DateRange | null, now = new Date()): DateRange | null {
  if (!range || range.start > range.end || range.start.startsWith("0000") || range.end.startsWith("9999")) return null;
  const today = iso(now);
  if (range.end === today) {
    const previous = new Date(now.getFullYear(), now.getMonth(), now.getDate()-1);
    const end = iso(previous);
    return end >= range.start ? { start: range.start, end } : null;
  }
  if (range.end > today) return null;
  const wholeMonth = calendarMonthRange(range.start.slice(0,7));
  if (period === "lastMonth" || (wholeMonth?.start === range.start && wholeMonth.end === range.end))
    return calendarMonthRange(previousCalendarMonth(range.start.slice(0,7)));
  return previousDateRange(range);
}
